import React, { Component } from 'react';
import PropTypes, { string } from 'prop-types';

import Typography from '@material-ui/core/Typography';
import red from '@material-ui/core/colors/red';
import { TextField, PasswordField, Button, LoadingIndicator, NavigationLink, AppBar } from '../components';
import { ThemeImages, ThemeColors } from '../theme';
import Config from '../../run-config';

import QueryString from 'query-string';

class Login extends Component {

  constructor(props) {
    super(props);
    this.state = {
      userName: '',
      password: '',
    };


    this.setUsername = this.setUsername.bind(this);
    this.setPassword = this.setPassword.bind(this);
    this.keyPress = this.keyPress.bind(this);
    this.login = this.login.bind(this);

    this.authorizedClients = ['AmazonSLA'];
  }

  componentWillMount() {
    const { client_id, state, redirect_uri } = QueryString.parse(this.props.location.search);
    this.setState({
      client_id,
      state,
      redirect_uri,
    });

    this.props.navigate('externalLogin');
  }

  setUsername(event) {
    this.setState({ userName: event.target.value });
  }

  setPassword(event) {
    this.setState({ password: event.target.value });
  }

  keyPress(event) {
    if (event.key === 'Enter') {
      this.login();
      event.preventDefault();
      return false;
    }
    return true;
  }

  post(path, params, method = 'post') {
    // The rest of this code assumes you are not using a library.
    // It can be made less wordy if you use one.
    const form = document.createElement('form');
    form.method = method;
    form.action = path;

    for (const key in params) {
      if (params.hasOwnProperty(key)) {
        const hiddenField = document.createElement('input');
        hiddenField.type = 'hidden';
        hiddenField.name = key;
        hiddenField.value = params[key];

        form.appendChild(hiddenField);
      }
    }

    document.body.appendChild(form);
    form.submit();
  }

  authorize = () => {
    const dto = {
      grant_type: 'code',
      client_id: this.state.client_id,
      state: this.state.state,
      redirect_uri: this.state.redirect_uri,
      response_type: 'code',
      code: this.props.accessToken,
    };

    this.post(`${Config.apiHost}/api/accounts/externalLogin`,
    dto);
  }

  login() {
    if (
      this.state.userName &&
      this.state.userName !== '' &&
      this.state.password &&
      this.state.password !== '' &&
      this.state.client_id &&
      this.state.state &&
      this.state.redirect_uri
      ) {
      const loginDto = {
        userName: this.state.userName,
        password: this.state.password,
        state: this.state.state,
        redirectUri: this.state.redirect_uri,
      };

      this.props.login(loginDto);
          // do something
    }
  }

  renderLoginForm() {
    if (this.props.loggedIn) return null;

    const formGroupStyle = {
      // width: '100%',
      textAlign: 'center',
      margin: '0 20px',
    };

    const LoginButton = (props) => {
      if (props.loading) {
        return <LoadingIndicator />;
      }

      return (<Button
        label="Einloggen"
        labelStyle={{ color: ThemeColors.darkTextOnPrimaryBackground ? 'black' : 'white' }}
        onClick={this.login}
        style={{ width: '100%' }}
        color="primary"
        variant="contained"
      />);
    };

    return (
      <div>
        <div
          style={{
            ...formGroupStyle,
            marginTop: 10,
          }}
        >
          <TextField
            autoFocus
            required
            placeholder="E-Mail"
            value={this.state.userName}
            onChange={this.setUsername}
          />
        </div>
        <div style={formGroupStyle}>
          <PasswordField
            required
            hintText="Passwort"
            value={this.state.password}
            onChange={this.setPassword}
          />
        </div>
        <div
          style={{
        // ...formGroupStyle,
            marginTop: 20,
            paddingBottom: 10,
          }}
        >
          <LoginButton {...this.props} />
        </div>,
      <div
        style={{
          ...formGroupStyle,
          marginTop: 20,
          paddingBottom: 10,
        }}
      />
      </div>
    );
  }

  renderAllowAccess() {
    if (!this.props.loggedIn) return null;
    const padding = {
      padding: 5,
      fontSize: 14,
    };

    if (!this.authorizedClients.includes(this.state.client_id)) {
      return (
        <Typography style={padding}>
        Ein nicht authorisierter Dienst möchte Zugang erhalten
        dieser Anfrage kann aus Sicherheitsgründen nicht zugestimmt
        werden.
      </Typography>
      );
    }

    if (this.state.client_id === 'AmazonSLA') {
      return (
        // <form onSubmit={this.handleSubmit} tar>
        //   <Typography style={padding}>
        //   Der SLA Amazon Alexa Skill möchte Zugriff auf ihr Konto erhalten.
        // </Typography>
        //   <input type="hidden" value={this.state.state} name="state" />
        //   <input type="hidden" value={this.state.redirect_uri} name="redirect_uri" />
        //   <input type="submit" value="Absenden" />
        // </form>


        <div>
          <Typography style={padding}>
          Der SLA Amazon Alexa Skill möchte Zugriff auf ihr Konto erhalten.
        </Typography>
          <Button
            label="Zugriff erlauben"
            labelStyle={{ color: ThemeColors.darkTextOnPrimaryBackground ? 'black' : 'white' }}
            onClick={this.authorize}
            style={{ width: '100%' }}
            color="primary"
            variant="contained"
          />
        </div>
      );
    }

    return <Typography>yup</Typography>;
  }

  render() {
    const containerStyle = {
      width: '300px',
      margin: '0 auto',
      backgroundColor: 'rgba(255, 255, 255, 0.8)',
      marginTop: 'calc(50vh - 300px)',
      boxShadow: '-10px 16px 40px rgba(93,87,87,.14)',
    };

    const errorContainerStyle = {
      backgroundColor: red[500],
      textAlign: 'center',
      color: 'white',
    };

    const ErrorMessage = (props) => {
      if (!props.errorMessage) {
        return null;
      }

      return (
        <div style={errorContainerStyle}>
          <span>{props.errorMessage}</span>
        </div>
      );
    };


    return (
      <form style={containerStyle} onKeyPress={this.keyPress} noValidate>
        <div style={{ padding: 20 }}>
          <img src={ThemeImages.logoPath} alt="Einrichtungsberater App Logo" style={{ width: '100%' }} />
        </div>
        <AppBar
          title="Login"
          defaultTypography
        />

        <ErrorMessage {...this.props} />
        {this.renderLoginForm()}
        {this.renderAllowAccess()}

      </form>
    );
  }
}

Login.propTypes = {
  login: PropTypes.func.isRequired,
};

export default Login;



// WEBPACK FOOTER //
// ./src/app/external_login/login.js